var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h-container"},[_c('Commonheader'),_c('div',{staticClass:"h-wrap"},[_c('leftMenu'),_c('div',{staticClass:"h-main"},[_c('router-view'),_c('Commonfooter')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }